import { useState } from 'react';

const useFilters = ({ filters, onChange } = {}) => {
    const [filtersState, setFiltersState] = useState<{ [key: string]: any[] }>(
        {},
    );

    const filterSet = filters || filtersState;
    const { page, page_size, ordering, search, ...controledFilters } =
        filterSet;
    const exportFilters = { all: true, ordering, search, ...controledFilters };

    const addFilter = (key: string, ...values: any[]) => {
        const newFilters = { ...controledFilters };
        if (newFilters[key]) {
            newFilters[key].push(...values);
        } else {
            newFilters[key] = values;
        }

        if (!filters) setFiltersState(newFilters);
        if (onChange) onChange(newFilters);
    };

    const removeFilter = (key: string, value: any) => {
        const newFilters = { ...filterSet };
        if (newFilters[key]) {
            newFilters[key] = newFilters[key].filter(val => val !== value);
        }
        if (!newFilters[key].length) delete newFilters[key];
        if (!filters) setFiltersState(newFilters);
        if (onChange) onChange(newFilters);
    };

    const hasFilter = (key: string, value: any) =>
        controledFilters[key]?.includes(value);

    const setFilter = (key: string, value: any) => {
        const newFilters = { ...controledFilters };
        newFilters[key] = value;
        if (!filters) setFiltersState(newFilters);
        if (onChange) onChange(newFilters);
    };

    return {
        filters: controledFilters,
        exportFilters,
        addFilter,
        removeFilter,
        hasFilter,
        setFilter,
    };
};

export default useFilters;
